// @flow
import configureEshopComponents from './configureEshopComponents';

export default (props) => {
	switch (props.decorator || props.is) {
		case 'AddSvgIconSprite':
			// COMMON: Komponenta pro AJAX nacteni SVG spritu
			return import('./components/AddSvgIconSprite');
		case 'WebLayout':
			return import('./components/WebLayout');
		case 'RadioSelect':
			// COMMON: Podpurna komponenta pro radio select group, ktera zpropaguje change eventu pro ucely PU (odeberte, pokud nepouzivate ve vypisu katalogu komponentu pro razeni ani komponenta pro prepnuti zobrazeni)
			return import('fg-frontend/src/components/RadioSelect');
		case 'CheckboxSelect':
			// COMMON: Komponenta pro podporu hromadneho zaskrtnuti ve skupine checkboxu (odeberte pokud nepouzivate ve vypisech produktu komponenty pro checkboxovou filtraci tagFilter, brandFilter, parameterFilter)
			return import('fg-frontend/src/components/CheckboxSelect');
		case 'SimpleCollapse':
			return import('fg-frontend/components/SimpleCollapse');
		case 'SizeGuide':
			return import('./components/SizeGuide');
		case 'SubmenuToggle':
			return import('./components/SubmenuToggle');
		case 'GalleryWebslider':
			return import('./components/GalleryWebslider');
		case 'Typeahead':
			return import('fg-frontend/components/Typeahead');
		case 'SelectDesign':
			return import('./components/SelectDesign');
		case 'ListToggle':
			return import('fg-frontend/components/ListToggle');
		case 'PasswordToggle':
			return import('fg-frontend/components/PasswordToggle');
		case 'SocialShare':
			// COMMON: Komponenta pro sdileni linku na socialni site (odeberte, pokud nepouzivate sdileni linku na socialni site, napr. v eshopu v detailu produktu)
			return import('fg-frontend/src/components/SocialShare');
		case 'AnchorsList':
			// COMMON: Zalozkovy seznam s kotvami (odeberte, pokud nepouzivate v detailu produktu)
			return import('fg-frontend/src/components/AnchorsList');
		case 'Slider':
			// COMMON: Intervalovy slider v1 bez podpory histogramu (odeberte, pokud nepouzivate ve vypisech produktu komponenty pro filtraci pomoci intervalu, napr. ceny, nebo pokud je pouzita komponeta RangeSlider)
			return import('fg-frontend/components/Slider');
		case 'RadioSelectTab':
			// COMMON: Komponenta pro zobrazeni skupiny radio buttonu formou zalozek (odeberte, pokud nepouzivate vychozi komponentu pro razeni produktu)
			return import('fg-frontend/src/components/RadioSelectTab');
		case 'NumberInput':
			// COMMON Komponenta pro nastaveni ciselneho mnozstvi (odeberte, pokud v projektu neni nakupni proces)
			return import('fg-frontend/components/NumberInput');
		case 'UniversalPaginationButton':
			// COMMON: Komponenta tlacitka Nacist dalsi v ramci strankovani
			return import('fg-frontend/components/UniversalPaginationButton');
		case 'Tooltip':
			return import('./components/Tooltip');
		case 'GtmHandler':
			return import('./components/GtmHandler');
		case 'TriggerInViewport':
			return import('./components/TriggerInViewport');
		case 'ShareUrl':
			return import('fg-frontend/src/components/ShareUrl');
		case 'PhotoSwipe':
			return import('./components/PhotoSwipe');
		case 'RedirectToUrl':
			return import('fg-frontend/src/components/RedirectToUrl');
		case 'Form':
			return import('fg-frontend/src/components/Form');
		case 'LazyImage':
			return import('./components/LazyImage');
		case 'Webslider':
			return import('fg-frontend/src/components/Webslider');
		case 'PrintPage':
			return import('fg-frontend/src/components/PrintPage');
		case 'PrintPdf':
			return import('fg-frontend/src/components/PrintPdf');
		case 'FileInput':
			return import('fg-frontend/src/components/FileInput');
		case 'RangeDatepicker':
			return import('fg-frontend/components/RangeDatepicker');
		case 'GoogleMap':
			// COMMON: Google Mapa
			return import('./components/GoogleMap');
		case 'GoogleRecaptcha':
			// COMMON: Google Recaptcha (odeberte pokud neupouzivate komponentu Google Recaptcha)
			return import('fg-frontend/src/components/GoogleRecaptcha');
    case 'FGUpload':
      // COMMON: Komponenta pro multi upload souboru (odeberte, pokud nepouzivate RJ fileUpload komponentu)
      return import('./components/FGUpload');
    case 'PreventDoubleClickHandler':
      // COMMON: Komponenta zajistuje deaktivaci odkazu po prvnim kliknuti
      return import('fg-frontend/src/components/PreventDoubleClickHandler');
		default:
			const eshopComponent = configureEshopComponents(props);
			if (eshopComponent) {
				return eshopComponent;
			} else {
				console.log(`Unknown component ${props.decorator || props.is}`);
				return null;
			}
	}
};



// WEBPACK FOOTER //
// ./fe/web-kanken/src/js/configureWebComponents.js